import React from 'react';
import AwardsCard from './AwardsCard';

export default function AwardsList() {
  return (
    <section className="awards-section">

      <h2 className="awards-section-title">Awards & Honors</h2>

      <AwardsCard
        year="2022"
        title="Data Science & Artificial Intelligence Hackathon Award"
        institution="Dedan Kimathi University of Technology — Center for Data Science and Artificial Intelligence (DSAIL)"
        position="Third Position"
        description="Recognized for innovative application of data science and AI techniques during a competitive university-wide hackathon."
      />

      <AwardsCard
        year="2022"
        title="Hack the Continent — Open Buildings Challenge"
        institution="Zindi Africa"
        position="First Position"
        description="Achieved top position in a continental challenge focused on geospatial data analysis and open building datasets."
        link="https://zindi.africa/learn/meet-the-winners-of-the-hack-the-continent-open-buildings-challenge"
      />

      <AwardsCard
        year="2020"
        title="Certificate of Merit for Academic Excellence"
        institution="Dedan Kimathi University of Technology"
        position="Third Position — BSc Geospatial Information Science & Remote Sensing"
        description="Awarded for outstanding academic performance in the first year of undergraduate study."
      />

    </section>
  );
}
